// Katalogdan Ürün Ekle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.catalogPicker';

export const catalogPickerGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Katalogdan ürün nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Hazır ürün kataloğundan seçtiğiniz ürünleri tek seferde stok kartı olarak stoğunuza aktarırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    list: t(`${G}.regions.list`, 'Sektör ve kategoriler'),
    form: t(`${G}.regions.form`, 'Arama ve ürün tablosu'),
    footer: t(`${G}.regions.footer`, 'Depo, miktar ve aktarım'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Katalogda 23 binden fazla ürün olduğu için liste kendiliğinden açılmaz. Ürünleri ya soldan sektör ve kategori seçerek ya da ürün adı / barkodla arayarak bulursunuz.'),
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Sektör ve kategori seçin'),
      text: t(`${G}.s2.text`, '"1. Sektör" bölümünden işletmenize uygun sektörü seçin. "2. Kategori → alt kategori" listesinde kategoriye tıklayarak açın; bir alt kategoriye tıklayınca ürünleri sağdaki tabloda listelenir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Kategori satırındaki kutuyu işaretlerseniz o kategorinin tüm ürünleri listelenmeden aktarıma eklenir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Arayın ve ürünleri işaretleyin'),
      text: t(`${G}.s3.text`, '"Ürün Adı" veya "Barkod" seçip arama kutusuna yazın. Tabloda bir satıra tıklayarak ürünü işaretleyin; başlıktaki kutu o sayfadaki tüm ürünleri seçer. Tablo ürün adı, barkod, kategori, birim ve KDV oranını gösterir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Farklı aramalardan ve kategorilerden yaptığınız seçimler aynı listede birikir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Depo ve miktarı belirleyin'),
      text: t(`${G}.s4.text`, 'Ürünlerin gireceği depoyu seçin (varsayılan depo önceden seçili gelir) ve "Miktar" kutusuna başlangıç stoğunu yazın; boş bırakılırsa her ürün 1 adet gelir. Altta kaç ürün ve kategori seçtiğiniz görünür.'),
      tips: [
        t(`${G}.s4.tip1`, 'Tek seferde en fazla 5.000 ürün aktarılır.'),
        t(`${G}.s4.tip2`, '"Seçimi Temizle" tüm işaretleri kaldırır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Stoğunuza aktarın'),
      text: t(`${G}.s5.text`, '"Stoğuma Aktar" seçilen ürünleri stok kartı olarak oluşturur; ilerleme çubuğu aşamaları gösterir. Bitince "Aktarım tamamlandı" mesajında kaç ürünün eklendiği yazar.'),
      tips: [
        t(`${G}.s5.tip1`, 'Katalogda fiyat yoktur: ürünler 0 satış fiyatıyla gelir, satış fiyatını sonradan girmelisiniz.'),
        t(`${G}.s5.tip2`, 'Kategoriler, katalogdaki sektör → kategori → alt kategori yapısıyla stoğunuzda otomatik oluşturulur; aynı adlı kategori varsa o kullanılır.'),
        t(`${G}.s5.tip3`, 'Eklenemeyen ürünler atlanır ve mesajda sayısı yazar; bunun en sık nedeni barkodun veya stok kodunun zaten stoğunuzda olmasıdır.'),
      ],
    },
  ],
});
